const lastUpdate = '2024-12-12'; //YYYY-MM-DD
export const helpTitle = 'Lat Long Converter Help';
export const helpContent = `
<h1>Lat Long Converter Help</h1>

<h2>Overview</h2>
<p>The Lat Long Converter allows you to convert latitude and longitude coordinates between different formats: Decimal Degrees (DD), Degrees and Decimal Minutes (DDM), and Degrees, Minutes, and Seconds (DMS). It also provides the GeoJSON representation of the coordinates.</p>

<h2>How to Use</h2>

<ol>
  <li><strong>Select the Conversion Format:</strong>
    <ul>
      <li>Choose the format you want to convert to by selecting one of the radio buttons:</li>
      <li><strong>Decimal Degrees (DD)</strong></li>
      <li><strong>Degrees and Decimal Minutes (DDM)</strong></li>
      <li><strong>Degrees, Minutes, and Seconds (DMS)</strong></li>
    </ul>
  </li>
  <li><strong>Enter Latitude and Longitude:</strong>
    <ul>
      <li>Enter the latitude and longitude values in the appropriate format based on your selection.</li>
      <li>Example inputs:</li>
      <li><strong>DD:</strong> 60.123 (latitude), -111.123 (longitude)</li>
      <li><strong>DDM:</strong> 60 1.23 or N60 1.23 (latitude), -111 7.38 or W111 7.38 (longitude)</li>
      <li><strong>DMS:</strong> 60 1 2.3 or N60 1 2.3 (latitude), -111 7 3.8 or W111 7 3.8 (longitude)</li>
    </ul>
  </li>
  <li><strong>Convert:</strong>
    <ul>
      <li>Click the "Convert" button to perform the conversion.</li>
      <li>The converted results will be displayed in the "Converted Results" textarea.</li>
    </ul>
  </li>
</ol>

<h2>Conversion Details</h2>
<ul>
  <li><strong>Decimal Degrees (DD):</strong> A numerical representation of coordinates where degrees are expressed as decimal values.</li>
  <li><strong>Degrees and Decimal Minutes (DDM):</strong> A format where degrees are followed by minutes expressed as decimal values.</li>
  <li><strong>Degrees, Minutes, and Seconds (DMS):</strong> A format where degrees are followed by minutes and seconds.</li>
  <li><strong>GeoJSON:</strong> A format for encoding a variety of geographic data structures using JavaScript Object Notation (JSON).</li>
</ul>

<h2>Example</h2>
<p>If you enter the following coordinates:</p>
<ul>
  <li>Latitude: 60 1 2.3 (DMS)</li>
  <li>Longitude: -111 7 3.8 (DMS)</li>
</ul>
<p>And select "Decimal Degrees (DD)" as the conversion format, the converted results will be:</p>
<ul>
  <li>Latitude: 60.0173056</li>
  <li>Longitude: -111.1177222</li>
</ul>

<p>The GeoJSON representation will be:</p>
<pre>
{
  "type": "Point",
  "coordinates": [-111.1177222, 60.0173056]
}
</pre>

<h2>Additional Information</h2>
<p>The converter will highlight the selected format in yellow.</p>
<p>Instructions for the selected format will be displayed below the conversion options.</p>

<p>For further assistance, please refer to the documentation or contact support.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;
